import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useTourContext } from "context/TourContext";
import { useAuth } from "context/AuthContext";
import { chuanHoaBuocTour, locBuocCoTarget } from "lib/tourDaXem";
import { dangChoLuong, timChangLuong } from "lib/luongTour";
import { BAT_HUONG_DAN } from "lib/batHuongDan";

/**
 * Orchestrator tour luồng lần đầu theo vai trò.
 * Gọi 1 lần từ App.js (trong Router). Khi pathname khớp một chặng của luồng
 * chưa xem, đăng ký steps "Chặng x/y" và tự chạy — ưu tiên hơn tour trang.
 */
export default function useLuongTour() {
  const { pathname } = useLocation();
  const { vaiTro, user, loading: dangTaiAuth } = useAuth();
  const { registerTour, unregisterTour, startActiveTour } = useTourContext();
  const uid = user?.uid ?? null;
  const flowId = BAT_HUONG_DAN ? dangChoLuong(vaiTro, uid) : null;
  const chang = flowId ? timChangLuong(flowId, pathname) : null;
  const changKey = chang?.key ?? "";

  useEffect(() => {
    if (!BAT_HUONG_DAN || dangTaiAuth || !flowId || !changKey) return undefined;

    const changHienTai = timChangLuong(flowId, pathname);
    if (!changHienTai) return undefined;

    const buocLoc = chuanHoaBuocTour(locBuocCoTarget(changHienTai.buoc()));
    if (!buocLoc.length) return undefined;

    registerTour(flowId, buocLoc, uid, {
      laLuong: true,
      laChangCuoi: changHienTai.laChangCuoi,
    });

    const henGio = setTimeout(() => startActiveTour(), 500);

    return () => {
      clearTimeout(henGio);
      unregisterTour(flowId);
    };
  }, [dangTaiAuth, flowId, changKey, pathname, uid, registerTour, unregisterTour, startActiveTour]);
}
